import styled from 'styled-components'

import MuiFormLabel from '@material-ui/core/FormLabel'

const FormLabel = styled(MuiFormLabel)`
  display: block;
  margin-bottom: 15px;
`

export default FormLabel
